import { Card, CardContent, CardHeader } from '@/shared/ui'
import { Button } from '@/shared/ui'
import { useTelegram } from '@/shared/lib/telegram'
import { Shield, CheckCircle } from 'lucide-react'

/**
 * Виджет: Авторизация через Telegram
 * 
 * Отображает приглашение к авторизации для неавторизованных пользователей
 * или информацию об авторизованном пользователе.
 * 
 * @example
 * ```tsx
 * <TelegramAuth />
 * ```
 */
export function TelegramAuth() {
  const { initData, webApp, hapticFeedback } = useTelegram()
  const isAuthenticated = !!initData

  const handleAuth = () => {
    hapticFeedback.impactOccurred('medium')
    // В Telegram Mini App авторизация происходит автоматически через initData
    // Если initData отсутствует, пользователь должен открыть приложение через Telegram
    webApp.showAlert('Откройте приложение через Telegram для авторизации')
  }

  if (isAuthenticated) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-success/10 rounded-lg">
              <CheckCircle className="w-5 h-5 text-success" />
            </div>
            <div>
              <p className="font-medium">Вы авторизованы</p>
              <p className="text-sm text-muted-foreground">
                Авторизация через Telegram активна
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Shield className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold">Авторизация</h3>
            <p className="text-sm text-muted-foreground">
              Войдите через Telegram для доступа к персональным функциям
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <Button
          variant="primary"
          fullWidth
          onClick={handleAuth}
          leftIcon={<Shield className="w-4 h-4" />}
        >
          Авторизоваться через Telegram
        </Button>
        <p className="mt-3 text-xs text-muted-foreground text-center">
          Авторизация происходит автоматически при открытии приложения через Telegram
        </p>
      </CardContent>
    </Card>
  )
}
